import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = "ab_admin_token";

export const auth = {
  get token() {
    return localStorage.getItem(TOKEN_KEY);
  },
  set token(v) {
    if (v) localStorage.setItem(TOKEN_KEY, v);
    else localStorage.removeItem(TOKEN_KEY);
  },
  clear() {
    localStorage.removeItem(TOKEN_KEY);
  },
  isAuthed() {
    return !!localStorage.getItem(TOKEN_KEY);
  },
};

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
  if (auth.token) cfg.headers["X-Admin-Token"] = auth.token;
  return cfg;
});
